
import { Component, Vue } from "vue-property-decorator";
import { InjectFunction } from "@common/src/utils/decorator";
import { namespace } from "vuex-class";
import Attachment from "@common/src/components/scope/attachment/index.vue";
const instruction = namespace("instruction");
@InjectFunction("dayjs")
@Component({ components: { Attachment } })
export default class Template extends Vue {
  @instruction.Action queryinstructionDetail;
  activeIndex = 0;
  handleSwitchTab(index) {
    this.activeIndex = index;
  }
  get id() {
    return this.$route.params.id || "";
  }
  instrctionData: any = {
    tutorialSheets: []
  };
  created() {
    this.queryinstructionDetail({
      tutorialCode: this.id
    }).then(data => {
      this.instrctionData = data.data;
    });
  }
}
